<template>
    <ResourceGroup></ResourceGroup>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ResourceGroup = defineAsyncComponent(() =>
    import("../../components/ITDepartment/ResourceGroup/ResourceGroup.vue")
);

export default {
    components: { ResourceGroup, AuthLayout },
};
</script>